import React, { forwardRef } from 'react'

export const Textarea = forwardRef((props, ref) => {
    const {
        hasError = false,
        errorMessage,
        disableHoverStyles = false,
        className = '',
        ...restProps
    } = props

    return (
        <>
            <textarea
                className={`h-[45px] w-full text-sm py-[10px] px-[15px] min-h-[100px] rounded border placeholder-opacity-50 placeholder-brand-black transition-color duration-200 disabled:cursor-not-allowed ${
                    disableHoverStyles ? 'hover:bg-brand-white' : 'hover:bg-brand-light-grey'
                } ${hasError ? 'border-brand-danger' : 'border-brand-grey'} ${
                    errorMessage ? 'mb-[5px]' : ''
                } ${className}`}
                ref={ref}
                {...restProps}
            />

            {errorMessage && (
                <p className={`text-xs mt-0 mb-[15px] text-brand-danger block`}>{errorMessage}</p>
            )}
        </>
    )
})
